import { SELLING_PLANS } from "./SellingPlans";

export function packPlanToLineItems(packPlan: any[], sellingPlanId: string) {
  const lineItems: any[] = [];

  for (const recipePlan of packPlan) {
    for (const pack of recipePlan.packs) {
      lineItems.push({
        merchandiseId: pack.variantId,
        quantity: pack.quantity,
        sellingPlanId,
        attributes: {
          recipeId: recipePlan.recipeId,
          packSize: pack.size,
          totalGrams: recipePlan.totalGrams,
        },
      });
    }
  }

  return lineItems;
}
